import KeyManager from "./KeyManager";
import InfoModule from "./InfoModule";
import MapModule from "./MapModule";

// Theme toggle
const effectiveTheme = () =>
    document.documentElement.dataset.theme ||
    (matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light');

document.querySelector('.theme-toggle').addEventListener('click', () => {
    document.documentElement.dataset.theme = effectiveTheme() === 'dark' ? 'light' : 'dark';
});

const info = new KeyManager("info", InfoModule);
const map = new KeyManager("map", MapModule);

document.addEventListener("keydown", event => {
    if (event.key.length !== 1) return;
    const keyCode = event.key.charCodeAt(0);

    [info, map].forEach(manager => {
        manager.check();

        manager.push(keyCode);

        if (manager.compare()) {
            const disableCb = manager.action();
            document.addEventListener("keydown", disableCb, { once: true });
        }
    });
});